import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import LabeledInput from 'modules/core/components/LabeledInput'
import MoneyField from 'modules/core/components/MoneyField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ClassWizardData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'
import {
  SalaryCostCalculator,
  SalaryCostInfo,
} from 'modules/trainings/components/SalaryCostCalculator'

export const CostsStep = ({ data, onDataChanged }: WizardStepRenderParams<ClassWizardData>) => {
  const { company } = useCurrentSession()
  const salaryCostInfo = new SalaryCostInfo(data.employeesSelection)
  data.trainingSessions.forEach((session) => {
    if (session.startsAt) {
      salaryCostInfo.appendFromBackend(session.startsAt, Number(session.duration) || 0)
    }
  })

  const currency = company.currency || ''

  return (
    <Box gap="s32" paddingX="s16">
      <Box gap="s16">
        <Box gap="s8">
          <Text size="400" weight="semibold" color="grey1000">
            {i18n.t('trainings.trainings_revamp.training_class.class_wizard.costs_step.title')}
          </Text>
          <Text size="200" weight="normal">
            {i18n.t(
              'trainings.trainings_revamp.training_class.class_wizard.costs_step.description'
            )}
          </Text>
        </Box>
        <LabeledInput
          isLegend
          label={i18n.t(
            'trainings.trainings_revamp.training_class.class_wizard.basic_information_step.cost'
          )}
          description={i18n.t('trainings.classes.cost_desc')}
        >
          <MoneyField
            currency={currency}
            placeholder="0.00"
            onChange={(value) => onDataChanged({ ...data, cost: value })}
            value={String(data.cost) || ''}
            maxDecimals={2}
            maxLength={6}
          />
        </LabeledInput>
        <LabeledInput
          isLegend
          label={i18n.t('trainings.classes.indirect_cost')}
          description={i18n.t('trainings.classes.indirect_cost_desc')}
        >
          <MoneyField
            currency={currency}
            placeholder="0.00"
            onChange={(value) => onDataChanged({ ...data, indirectCost: value })}
            value={String(data.indirectCost) || ''}
            maxDecimals={2}
            maxLength={6}
          />
        </LabeledInput>
        <LabeledInput
          isLegend
          label={i18n.t('trainings.classes.salary_cost')}
          description={i18n.t('trainings.classes.salary_cost_desc')}
        >
          <Box gap="s16" flexDirection="row" alignItems="center">
            <MoneyField
              currency={currency}
              placeholder="0.00"
              onChange={(value) => onDataChanged({ ...data, salaryCost: value })}
              value={String(data.salaryCost) || ''}
              maxDecimals={2}
              maxLength={6}
            />
            <SalaryCostCalculator
              salaryCostInfo={salaryCostInfo}
              onApply={(value: string) => {
                onDataChanged({ ...data, salaryCost: value })
                return true
              }}
              trackingSelectedFrom="group_creation"
              currency={currency}
            />
          </Box>
        </LabeledInput>
        <Callout type="info">
          <Text weight="bold" color="darker800" size="300">
            {i18n.t('trainings.classes.salary_hint_result')}
          </Text>{' '}
          = {i18n.t('trainings.classes.salary_hint_formula')}
        </Callout>
        <LabeledInput
          isLegend
          label={i18n.t(
            'trainings.trainings_revamp.training_class.class_wizard.basic_information_step.reviewed_subsidized_cost'
          )}
          description={i18n.t('trainings.classes.subsidized_cost_desc')}
        >
          <MoneyField
            currency={currency}
            placeholder="0.00"
            onChange={(value) => onDataChanged({ ...data, subsidizedCost: value })}
            value={String(data.subsidizedCost) || ''}
            maxDecimals={2}
            maxLength={6}
          />
        </LabeledInput>
      </Box>
    </Box>
  )
}
